export default __webpack_public_path__ + "f5980e023a042bb08560b801012ee397.woff";